<template>
  <div class="evaluation-viewer-answer">
    <h3>{{ title }}</h3>
    <div
      v-for="result in results"
      :key="result"
    >
      <evaluation-viewer-answer-item
        :type="question.type"
        :answers="question.$answers"
        :result="result"
      />
    </div>
  </div>
</template>

<script>
import EvaluationViewerAnswerItem from '@/modules/evaluation-viewer/components/evaluation-viewer-answer-item'
/**
   * 'EvaluationViewerAnswer' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerAnswer',
  components: {EvaluationViewerAnswerItem},
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  computed: {
    title () {
      return this.question.$result.length > 1 ? 'Respuestas' : 'Respuesta'
    },
    results () {
      if (typeof this.question.$result === 'object') {
        return this.question.$result
      } else {
        return [ this.question.$result ]
      }
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .evaluation-viewer-answer {
      h3{
        @include font-primary(14px, bold);
        text-transform: uppercase;
      }
    }
</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/components/evaluation-viewer-answer.vue